import { Box, Typography } from '@mui/material'
import useStyles from '../_styles'
import { workflowTunnelSx } from '../_styles'

export default function WorkflowPageShell({ children }: { children: React.ReactNode }) {
    const classes = useStyles()
    return (
        <Box className={classes.root}>
            <Box sx={workflowTunnelSx.workflowNav}>
                <Typography className={classes.title}>Compléter la demande de téléxpertise</Typography>
            </Box>
            <Box className={classes.content}>{children}</Box>
        </Box>
    )
}
